import { render } from "./RequestLogDetailsModal.vue?vue&type=template&id=68016e48&scoped=true"
import script from "./RequestLogDetailsModal.vue?vue&type=script&lang=js"
export * from "./RequestLogDetailsModal.vue?vue&type=script&lang=js"

import "./RequestLogDetailsModal.vue?vue&type=style&index=0&id=68016e48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68016e48"]])

export default __exports__